// extracted by mini-css-extract-plugin
module.exports = {"info":"styles_info__PiMBu","error":"styles_error__f2FwK","warning":"styles_warning__6JWzG","success":"styles_success__uIvOl"};